
import { LoginService } from '../login/login.service';
import { ValidateUserResponseModel } from '../../model/models';
import { CurrentPageWatcherService } from '../../shared/utils/CurrentPageWatcher';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Rx';
import { Router } from '@angular/router';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, OnDestroy {

  sub: Subscription;
  resetUrl : string='';
  
  constructor(private loginService : LoginService, private currentPageWatcherService: CurrentPageWatcherService, private router : Router) { 
    
  }

  ngOnInit() {
    this.currentPageWatcherService.pageChanged().emit("Home");
  }

  ngOnDestroy() {
  //  this.sub.unsubscribe();
  }

}



// WEBPACK FOOTER //
// ./src/app/login/reset-password/reset-password.component.ts